import {
  CREATE_SPARE_TRANSFER_ADVICE_SUCCESS,
  FETCH_ATA_NO_SUCCESS,
  FETCH_SPARE_PARTS_BY_QUERY_SUCCESS,
  FETCH_SPARE_TRANSFER_ADVICE_SUCCESS,
  GET_SPARE_TRANSFER_ADVICE_SUCCESS,
  GET_STA_COUNT_START,
  GET_STA_COUNT_SUCCESS,
  SAVE_SPARE_TRANSFER_ADVICE_QUERY,
} from '../../constants/ActionTypes';

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  quantity: {},
  ataNo: 0,
  staCount: 0,
  staSpareCount: 0,
  staCountLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_SPARE_TRANSFER_ADVICE_QUERY: {
      return {
        ...state,
        query: action.query,
      };
    }

    case GET_SPARE_TRANSFER_ADVICE_SUCCESS: {
      const query = { ...state.query };
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      };
    }

    case CREATE_SPARE_TRANSFER_ADVICE_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      };
    }

    case FETCH_SPARE_TRANSFER_ADVICE_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      };
    }

    case FETCH_SPARE_PARTS_BY_QUERY_SUCCESS: {
      return {
        ...state,
        quantity: action.data,
      };
    }

    case FETCH_ATA_NO_SUCCESS: {
      return {
        ...state,
        ataNo: action.data,
      };
    }

    case GET_STA_COUNT_SUCCESS: {
      return {
        ...state,
        staCount: action.count,
        staSpareCount: action.totalSpares,
        staCountLoading: false
      }
    }
    case GET_STA_COUNT_START: {
      return {
        ...state,
        staCountLoading: true
      };
    }

    default:
      return state;
  }
}
